<div class="content" [class.forPrint]="forPrint" [class.forScreen]="!forPrint">
  <div
    class="block"
    *ngFor="let block of data"
    [style.width.%]="prop(block, 'width', 100)"
  >
    <div *ngIf="block.type == 'title'" [style.width.%]="100">
      <h1
        [style.text-align]="prop(block.content, 'halign', 'center')"
        [style.font-weight]="'bold'"
      >
        {{ block.content.text }}
      </h1>
    </div>

    <div *ngIf="block.type == 'text'" [style.width.%]="100">
      <div
        [style.text-align]="prop(block.content, 'halign', 'left')"
        [style.font-weight]="'normal'"
      >
        {{ block.content.text }}
      </div>
    </div>

    <div *ngIf="block.type == 'logo'" [style.width.%]="100">
      <div [style.text-align]="prop(block.content, 'halign', 'center')">
        <img style="width: 160px;" src="assets/logos/Logo_VidaSecurity.svg" />
      </div>
    </div>

    <div *ngIf="block.type == 'image'" [style.width.%]="100">
      <div [style.text-align]="prop(block.content, 'halign', 'center')">
        <img
          [style.width.pt]="prop(block.content, 'width', 'auto')"
          [style.height.pt]="prop(block.content, 'height', 'auto')"
          [src]="block.content.src"
        />
      </div>
    </div>

    <div *ngIf="block.type == 'pageBreak'" class="saltopagina"></div>

    <div *ngIf="block.type == 'chart'" [style.width.%]="100">
      <h1 [style.font-weight]="'bold'">
        {{ block.title }}
      </h1>
      <div [style.text-align]="prop(block.content, 'halign', 'center')">
        <img [style.width.%]="100" [src]="block.content.src" />
      </div>
    </div>

    <ng-container *ngIf="block.type == 'list'" [style.width.%]="100">
      <ul>
        <ng-template #recursiveList let-list>
          <li
            *ngFor="let item of list"
            [class.sublist-item]="isArray(item)"
            [class.plain-item]="!isArray(item)"
          >
            <ul *ngIf="isArray(item); else plain_item">
              <ng-container
                *ngTemplateOutlet="recursiveList; context: { $implicit: item }"
              ></ng-container>
            </ul>
            <ng-template #plain_item>{{ item }}</ng-template>
          </li>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            recursiveList;
            context: { $implicit: block.content.list }
          "
        ></ng-container>
      </ul>
    </ng-container>

    <table
      *ngIf="block.type == 'table'"
      [class.forPrint]="forPrint"
      [class.forScreen]="!forPrint"
      [style.table-layout]="tableLayout(block)"
    >
      <colgroup *ngIf="block.content.size && block.content.size.columns">
        <col
          *ngFor="let width of block.content.size.columns"
          [style.width.%]="width"
        />
      </colgroup>
      <tr
        *ngFor="let row of block.content.table; index as i"
        [style.height.rem]="rowHeight(i, block)"
      >
        <ng-container *ngFor="let cell of row">
          <th
            *ngIf="cell.type == 'header'"
            [class.forPrint]="forPrint"
            [class.forScreen]="!forPrint"
            [style.color]="prop(cell, 'color', '#443e68')"
            [style.background]="prop(cell, 'background', '#f7f7fa')"
            [style.padding]="prop(cell, 'padding', '0px 5px')"
            [style.vertical-align]="prop(cell, 'valign', 'middle')"
            [style.text-align]="prop(cell, 'halign', 'center')"
            [attr.colspan]="prop(cell, 'colspan', 1)"
            [attr.rowspan]="prop(cell, 'rowspan', 1)"
          >
            {{ formatValue(cell) }}
          </th>
          <td
            *ngIf="cell.type != 'header'"
            [class.forPrint]="forPrint"
            [class.forScreen]="!forPrint"
            [style.color]="prop(cell, 'color', '#443e68')"
            [style.padding]="prop(cell, 'padding', '0px 5px')"
            [style.vertical-align]="prop(cell, 'valign', 'middle')"
            [style.text-align]="prop(cell, 'halign', 'center')"
            [attr.colspan]="prop(cell, 'colspan', 1)"
            [attr.rowspan]="prop(cell, 'rowspan', 1)"
          >
            {{ formatValue(cell) }}
          </td>
        </ng-container>
      </tr>
    </table>

    <div
      *ngIf="block.type == 'table-resumen'"
      [class.forPrint]="forPrint"
      [class.forScreen]="!forPrint"
      [style.table-layout]="tableLayout(block)"
    >
      <div style="background: #f7f7fa; padding: 16px;">
        <div *ngFor="let row of block.content.table; index as i">
          <div class="row-resumen">
            <div class="cell-resumen" *ngFor="let cell of row">
              <div class="header-resumen">{{ cell.header }}</div>
              <div class="value-resumen">{{ cell.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <tr *ngFor="let row of block.content.table; index as i" [style.height.rem]="rowHeight(i, block)">
                <ng-container *ngFor="let cell of row">
                    <th *ngIf="cell.type == 'header'" [class.forPrint]="forPrint" [class.forScreen]="!forPrint" [style.vertical-align]="prop(cell, 'valign', 'middle')" [style.text-align]="prop(cell, 'halign', 'center')" [attr.colspan]="prop(cell, 'colspan', 1)" [attr.rowspan]="prop(cell, 'rowspan', 1)">
                        {{ formatValue(cell) }}
                    </th>
                    <td *ngIf="cell.type != 'header'" [class.forPrint]="forPrint" [class.forScreen]="!forPrint" [style.vertical-align]="prop(cell, 'valign', 'middle')" [style.text-align]="prop(cell, 'halign', 'center')" [attr.colspan]="prop(cell, 'colspan', 1)" [attr.rowspan]="prop(cell, 'rowspan', 1)">
                        {{ formatValue(cell) }}
                    </td>
                </ng-container>
            </tr> -->
    </div>

    <div *ngIf="block.type == 'downloads'" [style.width.%]="100">
      <ul class="download-list">
        <li *ngFor="let item of block.content.list" class="download-list-item">
          <a [href]="item.url" target="_blank" rel="noopener noreferrer">
            <span class="download-title">{{ item.title }}</span>
            <span class="download-url">{{ item.url }}</span>
            <svg-icon
              class="download-icon"
              src="../../../assets/icons/download.svg"
            ></svg-icon>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
